// ====================================================================================
// tooltip.module
// ====================================================================================
import { Tooltip } from "bootstrap";

export const init = () => {
  let tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  let tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );

  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    tooltipTriggerEl.addEventListener('show.bs.tooltip', () => {
      tooltipTriggerEl.classList.add('open');
    })
    tooltipTriggerEl.addEventListener('hide.bs.tooltip', () => {
      tooltipTriggerEl.classList.remove('open');
    })
  });
};
